<template>
  <div></div>
</template>

<script>
import { Account, Cms } from "@/api";
export default {
  created() {
    var code = this.$route.query.code;
    this.redirect = this.$route.query.state
    this.logonForConnect(code);
  },
  destroyed() {
    let key = 'wxRedirectUrl'
    this.$mdUtils.remove(key)
  },
  methods: {
    logonForConnect(code) {
      this.$api(Account.LogOnForConnect, {
        Code: code,
        AppId: process.env.VUE_APP_WX_APP_ID,
        Platform: 2
      }, false, false)
      .then(this.cmsLogOn)
      .catch((err) => {
        let params = {}
        if (err && err.ErrorCode === '11000') {
          params.Code = code;
          params.isWxLogErr = true;
          params.Platform = 2
        }
        this.$router.replace({ name: "login", params, query: {redirect: this.redirect} });

      })
    },
    cmsLogOn(req) {
      localStorage.setItem('lastRefishTokenTime', new Date())
      this.$mdUtils.setTokenPack(req.TokenPack);
      this.$api(Cms.Logon, { Id: req.UserInfo.Member.Id })
      .then((result) => {
        if (!result) {
          this.$tips.error('数据异常，请退出重新登录')
          this.$router.replace({ path: '/login'});
          return 
        }
        this.$mdUtils.setUserInfo(result);
        this.$router.replace({ path: this.redirect});
      }).catch(()=> {
        this.jumpLogin(req)
      })
    },
    jumpLogin(data) {
      this.$mdUtils.clearInfo()
      this.$router.replace({ name: "login", params: data.Body, query: {redirect: this.redirect} });
    }
  }
};
</script>


